// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__13IdX","errorLogs":"EditorFooter_errorLogs__12REs"};